import { ModalContext } from "dash-ui";
import { useContext } from "react";

const LimitedAccessBanner = ({
  propertyDetailsLimitMessage,
}: {
  propertyDetailsLimitMessage?: boolean;
}) => {
  const { toggleModal } = useContext(ModalContext);

  return (
    <div
      className={`p-2 text-md rounded-md border border-orange-600 bg-orange-50 gap-2 text-orange-600 w-full text-center justify-center items-center mb-4`}
    >
      {propertyDetailsLimitMessage && (
        <>
          <p className="text-lg">
            <b>You currently don't have access to this property!</b>
          </p>
          <br />
        </>
      )}
      <p>
        You have <b>free</b> access to the details of a <b>limited</b> number of
        properties.
      </p>
      <p>
        <span
          className="underline cursor-pointer"
          onClick={() => toggleModal(true, "UpgradeSubscriptionModal")}
        >
          Start your Free Trial
        </span>{" "}
        right now to get full access to <b>400+ New Developments</b> to boost
        your sales!
      </p>
    </div>
  );
};

export default LimitedAccessBanner;
